// Redesign 2026 – Kariéra: karusel kategorií a výběr kategorie ve výpisu pozic.
//
// Bez JS jsou vidět všechny pozice a karusel se dá posouvat jen tažením / kolečkem – stránka
// funguje dál, výběr kategorie je jen zrychlení. Nefiltruje se serverem, pozic je řádově desítky.
//
// Markup (includes/template-parts/redesign/kariera/pozice.php): [data-rd-kariera] s popisky tlačítka
// v data-label-on/off, šipky [data-rd-kariera-prev|next], pás dlaždic [data-rd-kariera-track]
// s dlaždicemi [data-rd-kariera-cat="<klíč>"] (prázdný klíč = všechny pozice), řádky pozic
// [data-rd-kariera-row="<klíč>"] v [data-rd-kariera-list], hláška [data-rd-kariera-empty].

const ACTIVE = 'is-active';

export default function initRedesignKariera() {
  const root = document.querySelector('[data-rd-kariera]');
  if (!root) {
    return;
  }

  const track = root.querySelector('[data-rd-kariera-track]');
  const tiles = [...root.querySelectorAll('[data-rd-kariera-cat]')];
  const rows = [...root.querySelectorAll('[data-rd-kariera-row]')];
  const list = root.querySelector('[data-rd-kariera-list]');
  const empty = root.querySelector('[data-rd-kariera-empty]');
  const anchor = document.getElementById('pozice-vypis');
  const labelOn = root.dataset.labelOn || '';
  const labelOff = root.dataset.labelOff || '';

  const scrollTrack = (direction) => {
    if (track) {
      track.scrollBy({ left: direction * Math.max(240, track.clientWidth * 0.75), behavior: 'smooth' });
    }
  };

  root.querySelector('[data-rd-kariera-prev]')?.addEventListener('click', () => scrollTrack(-1));
  root.querySelector('[data-rd-kariera-next]')?.addEventListener('click', () => scrollTrack(1));

  const apply = (key) => {
    let shown = 0;

    rows.forEach((row) => {
      const match = key === '' || row.dataset.rdKarieraRow === key;
      row.hidden = !match;
      if (match) {
        shown += 1;
      }
    });

    tiles.forEach((tile) => {
      const isActive = tile.dataset.rdKarieraCat === key;
      const button = tile.querySelector('button');
      tile.classList.toggle(ACTIVE, isActive);
      if (button) {
        button.classList.toggle('rd-btn--primary', isActive);
        button.classList.toggle('rd-btn--secondary', !isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.textContent = isActive ? labelOn : labelOff;
      }
    });

    if (list) {
      list.hidden = shown === 0;
    }
    if (empty) {
      empty.hidden = shown > 0;
    }
  };

  // klik kamkoli na dlaždici (jako v návrhu), tlačítko v ní je hlavní ovládací prvek pro klávesnici
  track?.addEventListener('click', (event) => {
    const tile = event.target.closest('[data-rd-kariera-cat]');
    if (!tile) {
      return;
    }

    apply(tile.dataset.rdKarieraCat);
    // odsazení pod sticky hlavičkou řeší scroll-margin-top kotvy (_kariera.scss)
    anchor?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
